import { CircularProgress, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { formatNumberWithComma } from "../../config";
import { apiGatewayAxiosInstance } from "../../utils/axios";

export default function SMSCampaignReport({ campaignData, setErrorResponse }) {
    // const botId = campaignData.otherDetails.botDetails.config.rbmClientId;
    /* Counts */
    // SMS
    // const [totalSMS, setTotalSMS] = useState();
    // const [sentSMS, setSentSMS] = useState();
    // const [deliveredSMS, setDeliveredSMS] = useState();
    // const [failedSMS, setFailedSMS] = useState();
    const [counts, setCounts] = useState({
        totalSMS: 0,
        sentSMS: 0,
        deliveredSMS: 0,
        failedSMS: 0,
    });

    /* Loaders */
    // SMS
    // const [totalSMSLoading, setTotalSMSLoading] = useState(false);
    // const [sentSMSLoading, setSentSMSLoading] = useState(false);
    // const [deliveredSMSLoading, setDeliveredSMSLoading] = useState(false);
    // const [failedSMSLoading, setFailedSMSLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    // const getCampaignMISReports = async (messageStatus, setter, setLoading) => {
    //     try {
    //         setLoading(true);
    //         const response = await apiGatewayAxiosInstance.get(`/conversation_logger/logger/get-campaign-reports-paralley`, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             params: {
    //                 campaignId: campaignData._id,
    //                 status: messageStatus,
    //                 botId: botId,
    //                 executedDate: campaignData.executedTime,
    //                 startDate: campaignData.startTime,
    //             },
    //         });

    //         if (response.status === 200) {
    //             const value = Object.values(response.data.campaignReportDetails);
    //             setter(Object.values(response.data.campaignReportDetails)[0]);
    //         } else {
    //             throw new Error(response);
    //         }
    //     } catch (error) {
    //         let errorMessage = "Server not reachable.";
    //         if (error.response) {
    //             errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
    //         }
    //         setErrorResponse(errorMessage);
    //     }
    //     setLoading(false);
    // };
    const getCampaignReportFromCampaignMIS = async () => {
        try {
            setLoading(true);
            const response = await apiGatewayAxiosInstance.get(`/mis_server/campaign/get-reports-for-list-campaigns`, {
                headers: {
                    "Content-Type": "application/json",
                },
                params: {
                    campaignId: campaignData._id,
                    executedTime: campaignData.executedTime,
                    startTime: campaignData.startTime,
                },
            });
            setLoading(false);
            if (response.status === 200) {
                setCounts(response.data);
            } else {
                throw new Error(response);
            }
        } catch (error) {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (campaignData.isSMSFallbackRequired) {
            // getCampaignMISReports(MessageStatusForCount.TotalSMSCount, setTotalSMS, setTotalSMSLoading);
            // getCampaignMISReports(MessageStatusForCount.Sms, setSentSMS, setSentSMSLoading);
            // getCampaignMISReports(MessageStatusForCount.SmsDELIVERED, setDeliveredSMS, setDeliveredSMSLoading);
            // getCampaignMISReports(MessageStatusForCount.TotalSMSFailed, setFailedSMS, setFailedSMSLoading);
            getCampaignReportFromCampaignMIS();
        }
    }, []);

    /* ================================================================= (UI) =================================================================== */
    return (
        <Grid
            container
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
            }}
        >
            <Grid
                item
                md={12}
                sx={{
                    // display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    flexWrap: "wrap !important",
                }}
                gap={15}
            >
                {campaignData?.isSMSFallbackRequired ? (
                    <>
                        <Grid>
                            <Typography
                                sx={{
                                    fontSize: "0.7rem !important",
                                    fontWeight: "bold",
                                }}
                            >
                                TOTAL :{" "}
                                {loading ? (
                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                ) : (
                                    formatNumberWithComma(counts.totalSMS) ?? "-"
                                )}
                            </Typography>
                        </Grid>
                        <Grid>
                            <Typography
                                color="primary"
                                sx={{
                                    display: "flex",

                                    fontSize: "0.7rem !important",
                                    fontWeight: "bold",
                                }}
                            >
                                {/* <RcsSentIcon /> */}
                                SENT :{" "}
                                {loading ? (
                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                ) : (
                                    formatNumberWithComma(counts.sentSMS) ?? "-"
                                )}
                            </Typography>
                        </Grid>
                        <Grid>
                            <Typography
                                color="green"
                                sx={{
                                    display: "flex",

                                    fontSize: "0.7rem !important",
                                    fontWeight: "bold",
                                }}
                            >
                                {/* <RcsDeliveredIcon /> */}
                                DELIVERED :{" "}
                                {loading ? (
                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                ) : (
                                    formatNumberWithComma(counts.deliveredSMS) ?? "-"
                                )}
                            </Typography>
                        </Grid>
                        <Grid>
                            <Typography
                                color="error"
                                sx={{
                                    display: "flex",
                                    fontSize: "0.7rem !important",
                                    fontWeight: "bold",
                                }}
                            >
                                {/* <Unpublished fontSize='small' sx={{ margin: "5px" }} /> */}
                                FAILED :{" "}
                                {loading ? (
                                    <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={15} />
                                ) : (
                                    formatNumberWithComma(counts.failedSMS) ?? "-"
                                )}
                            </Typography>
                        </Grid>
                    </>
                ) : (
                    "-"
                )}
            </Grid>
        </Grid>
    );
}
